import { Pipe, PipeTransform } from '@angular/core';

import { contentDateToMilliseconds } from '../utils';

/**
 * Normalizes a content date so it can be handed to Angular's `date` pipe.
 *
 * Content V2 returns ISO strings while the V1 public content queries still return epoch seconds,
 * and `date` cannot interpret the latter. Chain the two:
 *
 * `{{ item.publishedAt | contentDate | date: 'dd.MM.yyyy' }}`
 */
@Pipe({
  name: 'contentDate',
  standalone: true,
})
export class ContentDatePipe implements PipeTransform {
  transform(value: string | number | null | undefined): number | null {
    return contentDateToMilliseconds(value);
  }
}
